import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export const ITFLSSteppersMap = {
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investment: "Investment selection",
    review: "Review",
    doc: "Documents/Declaration",
    comfirm: "Confirmation",
    incomePayment: "Income payment details",
    drawdown: "Drawdown details"
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.Npr]: "Pension",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Wrap Cash",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};

export const DocumentsAndDeclarationContent = {
    header: "Documents",
    clientDeclaration: {
        header: "Client Declaration",
        label: "Please have your client complete the following document then upload a completed copy",
        uploadLabel: (firstname: string, lastname: string) => `${firstname} ${lastname} declaration to proceed`,
        uploadInstruction: "Upload completed client declaration",
        successfullyUploaded: "Client declaration uploaded successfully",
    },
    documentsToPost: {
        header: "Documents to post"
    },
    documentsAvailable: {
        header: "Documents available",
        label: "All documents have been collated into a single bundle which you can download or email"
    },
    declarations: {
        header: "Declarations",
        authorityToProceed: "I have the authority to proceed from the client",
        checkedAddress: "I have checked the client's address on Wrap and confirm it's their personal home address",
        confirmList: "I confirm all of the following:",
        firstConfirm: "The client has been provided with the relevant information, including the Wrap Client Terms and Conditions (wrapp66), and that they have had reasonable opportunity to read it.",
        secondConfirm: "The client has signed the Acceptance of Wrap Services Client Terms and Conditions forms and this will be submitted as evidence of my authority to proceed and to activate the account.",
        thirdConfirm: "The client has been provided with the relevant information, including the Product Terms and Conditions, the KFD and the relevant KID(s), SID(s) and KIID(s), and they have had reasonable opportunity to read them.",
        fourConfirm: "All documentation submitted by me will include the account number allocated to this application",
        explainedDataProtection: "Data protection  and money laundering requirements have been explained to all applicants (including, where applicable, lives assured)",
        confirmAll: "Confirm all"
    },
    validation: {
        mustAcceptAll: "You must accept all items to continue",
        uploadDeclaration: "You must upload client declaration to continue"
    }
};